module.exports = __webpack_public_path__ + "static/img/wenjuanewm.6fc9a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenjuanewm.png
// module id = L2j4
// module chunks = 1